import React from 'react'

import {__isAvailable} from "../../../_helpers/commons/utility.helper";
import styled from "@emotion/styled";
import sv from "../../../styles/styles";
import {ZoomPitchContents, ZoomPitchViewTypes} from "./ZoomPitchContents";
import {Box, BoxContainer} from "../../../styles/BoxStyles";

// STYLE ##########################################################

const LandingPitchContainer = styled(`div`)`
    ${sv.flexColumn};
    justify-content: space-around;
    align-items: center;
    margin: 0;
    padding: 15px;
    background: white;
    border-radius: 5px;
    @media(max-width: 1024px) {
        max-width: 600px;
        margin: 0;
    }
`;

const BoxPitchContainer = styled(`div`)`
    ${sv.flexColumn};
    align-items: center;
    div:last-child { margin-top: 25px; }
`;

// COMPONENT ##########################################################

const ZoomPitchView =  ({isLoggedIn, minHeight, viewType, isZoomAvailable}) => {

		const isZoomLandingPage = __isAvailable(viewType) && viewType === ZoomPitchViewTypes.LANDING;
		const zoomPitchContents = <ZoomPitchContents isLoggedIn={isLoggedIn} viewType={viewType} isZoomAvailable={isZoomAvailable}/>

		return (
			<>
				{/* if zoom landing page */}
				{ isZoomLandingPage &&
				<LandingPitchContainer>
					{zoomPitchContents}
				</LandingPitchContainer>
				}

				{/* if zoom promotion box */}
				{ !isZoomLandingPage &&
				<BoxContainer>
					<Box minHeight={minHeight}>
						<BoxPitchContainer>
							{zoomPitchContents}
						</BoxPitchContainer>
					</Box>
				</BoxContainer>
				}
			</>
		);
};

const connectedPitchView = ZoomPitchView;
export { connectedPitchView as ZoomPitchView };
